import React,{useEffect,useState,Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import Panel from '../components/Panel';
import Content from '../components/Content';
import Expanded from '../components/Expanded';
import Progress from '../components/Progress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import HomeIcon from '../assets/img/home-icon.svg';


const Question2 = (props) => {

    // const [q2,getQ2] = useState(50);
    const [isAnswered,setIsAnswered] = useState(false);
    const history = useHistory();
    const [isExtraOpen, setIsExtraOpen] = useState(false);

    const getInput = e => {
        const t = e.currentTarget.value;
        props.getQ2(t);
    }

    const checkInput = e => {
        setIsAnswered(true)
        e.preventDefault();
    }

    return(
        <QuestionPage className="turq">
            <Panel className="turq" setBG="bp2">
                <div className="process-title">business process #2</div>
                </Panel>
            {!isAnswered ?
                    <Content preAns isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1 className="main-q">care center efficiency</h1>
                    <h2 className="question-title">What is your average time to answer (call and chat)?</h2>
                    <form onSubmit={checkInput} action="">
                        <br></br>    
                        <br></br>      
                        <input className="default-slider seconds" required onChange={getInput} type="range" min="1" max="100" />  <LivePerc>{props.q2 == undefined || null ? '50' : props.q2} Seconds</LivePerc>
                        <br></br>
                        <CalculateButton />
                    </form>
                </Content>

                :
                <Content preAns={false} isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    {props.q2 < 45 ?
                    <Fragment>
                        <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">care center efficiency</h1>
                        <div className="determined-benchmark">You are <span>ahead</span> of the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>Our research found that the industry average for time to answer is 45 seconds.</p>
                                <p>Whether you’re above or below this rate, the faster a customer’s issue, concern or question is addressed, the higher the satisfaction rate and the lower the cost of care per event.</p>
                                <p>Your goal should be to decrease time to answer, no matter how you stack up against the benchmark.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                        <p>Amdocs offers end-to-end robotic process automation (RPA) services to automate rote and repetitive processes, so you can free your care agents to engage with customers faster and accelerate issue resolution.</p>
                        <p>Our RPA services help by:</p>
                        <ul>
                            <li><b>Accelerating</b> the identification of which processes are prime candidates for automation</li>
                            <li><b>Providing</b> fast on-boarding and implementation of these processes</li>
                            <li><b>Leveraging</b> chatbots to handle predefined issues to open agent capacity</li>
                            <li><b>Enabling</b> central control of automation and RPA tool management</li>
                        </ul>
                        <p>This in turn, allows you realize many benefits, including:</p>
                        <ul>
                            <li><b>Eliminating</b> time spent on cross-application desktop activities so the customer doesn’t have to wait for the agent to deal with data</li>
                            <li><b>Avoiding</b> the need for the customer to repeat the same information to different agents</li>
                            <li><b>Reducing time</b> required to provide answers and resolve issues, thereby improving the customer experience</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question3')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>        
                        
                    </Fragment>

                    : props.q2 == 45 ?
                    <Fragment>
                        <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">care center efficiency</h1>
                        <div className="determined-benchmark">You are <span>exactly</span> in line with the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>Our research found that the industry average for time to answer is 45 seconds.</p>
                                <p>Whether you’re above or below this rate, the faster a customer’s issue, concern or question is addressed, the higher the satisfaction rate and the lower the cost of care per event.</p>
                                <p>Your goal should be to decrease time to answer, no matter how you stack up against the benchmark.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                        <p>Amdocs offers end-to-end robotic process automation (RPA) services to automate rote and repetitive processes, so you can free your care agents to engage with customers faster and accelerate issue resolution.</p>
                        <p>Our RPA services help by:</p>
                        <ul>
                            <li><b>Accelerating</b> the identification of which processes are prime candidates for automation</li>
                            <li><b>Providing</b> fast on-boarding and implementation of these processes</li>
                            <li><b>Leveraging</b> chatbots to handle predefined issues to open agent capacity</li>
                            <li><b>Enabling</b> central control of automation and RPA tool management</li>
                        </ul>
                        <p>This in turn, allows you realize many benefits, including:</p>
                        <ul>
                            <li><b>Eliminating</b> time spent on cross-application desktop activities so the customer doesn’t have to wait for the agent to deal with data</li>
                            <li><b>Avoiding</b> the need for the customer to repeat the same information to different agents</li>
                            <li><b>Reducing time</b> required to provide answers and resolve issues, thereby improving the customer experience</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question3')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>                
                    </Fragment>
                    : props.q2 > 45 ?
                    <Fragment>
                    <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                    <h1 className="main-q">care center efficiency</h1>
                        <div className="determined-benchmark">You are <span>behind</span> the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>Our research found that the industry average for time to answer is 45 seconds.</p>
                                <p>Whether you’re above or below this rate, the faster a customer’s issue, concern or question is addressed, the higher the satisfaction rate and the lower the cost of care per event.</p>
                                <p>Your goal should be to decrease time to answer, no matter how you stack up against the benchmark.</p>
          
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                        <p>Amdocs offers end-to-end robotic process automation (RPA) services to automate rote and repetitive processes, so you can free your care agents to engage with customers faster and accelerate issue resolution.</p>
                        <p>Our RPA services help by:</p>
                        <ul>
                            <li><b>Accelerating</b> the identification of which processes are prime candidates for automation</li>
                            <li><b>Providing</b> fast on-boarding and implementation of these processes</li>
                            <li><b>Leveraging</b> chatbots to handle predefined issues to open agent capacity</li>
                            <li><b>Enabling</b> central control of automation and RPA tool management</li>
                        </ul>
                        <p>This in turn, allows you realize many benefits, including:</p>
                        <ul>
                            <li><b>Eliminating</b> time spent on cross-application desktop activities so the customer doesn’t have to wait for the agent to deal with data</li>
                            <li><b>Avoiding</b> the need for the customer to repeat the same information to different agents</li>
                            <li><b>Reducing time</b> required to provide answers and resolve issues, thereby improving the customer experience</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question3')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>                
                    </Fragment>
                    : 
                    <Fragment></Fragment>
                    }
                </Content>
            }
           
           <Progress prog={40} />

        </QuestionPage>
    )
}

const QuestionPage = styled(motion.div)`
    width: 100%;
    height: 100%;
    overflow-x: hidden !important;
    display: flex;

    @media (max-width: 1060px) {
        flex-direction: column;
    }
`;

const IndustryBenchmark = styled.h3`
    font-family: 'MarkPro-ExtraLight';
    margin-bottom: 20px;
`;

const TextInfo = styled.div`
    display: flex;

    div{
        flex: 1;
        margin-right: 50px;
    }

`;


const NextPage = styled.div`
   font-family: 'MarkPro-Bold';
    color: #fff;
    background: #EAB330;
    text-align: center;
    position: fixed;
    bottom: 60px;
    right: 0;
    font-size: 1.5em;
    padding: 15px;
    cursor: pointer;
    z-index:1000;

    @media (max-width: 1060px) {
        display: block;
        position: static;
        margin-top: 30px;
    }

`;

const NextArrow = styled(FontAwesomeIcon)`
    margin-left: 10px;
`;



const CalculateButton = styled.input.attrs({ 
    type: 'submit',
    value: 'submit'
  })`
    background: #333147;
    color: #fff;
    cursor: pointer;
    margin-bottom: 0;
    border-color: transparent;
    box-shadow: 0px;
    outline: none;
    text-align: center;
    font-family: 'MarkPro-Bold';
    padding: 10px;
    font-size: 1.3em;
    width: 130px;
    margin-top: 30px;
  `


const LivePerc = styled.span`
    font-family: 'MarkPro-Bold';
    font-size: 2em;
    margin-left: 30px;

    @media (max-width: 1060px) {
        margin-left: 0;
    }
`;


const DummyContainer = styled(motion.div)`
    display: contents;
`;

const HomeButton = styled.div`
    display: block;
    width: 70px; 
    height: 70px;
    border-radius: 100px;
    position: absolute;
    top: 20px;
    left: 20px;
    background: url(${HomeIcon}) no-repeat center center;
    background-size: 60%;
    background-color: #333147;
    cursor: pointer;

    @media (max-width: 1060px) {
        width: 62px;
        height: 62px;
    }
`;

export default Question2;